"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransitProvider = void 0;
const react_1 = __importDefault(require("react"));
const useTransitReducer_1 = __importDefault(require("./useTransitReducer"));
const TransitContext_1 = require("./TransitContext");
const react_use_1 = require("react-use");
exports.TransitProvider = ({ children, accessContext, autoLogin = true }) => {
    const [state, dispatch] = useTransitReducer_1.default();
    const isFirstRender = react_1.default.useRef(true);
    const [activeProviderIndex, setActiveProviderIndex, removeActiveProviderIndex] = react_use_1.useLocalStorage('active-provider-index', state.activeProviderIndex);
    const login = ({ providerIndex, accountName, authorization }) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            dispatch({ type: 'LOGIN_START' });
            const selectedProvider = accessContext.getWalletProviders()[providerIndex];
            if (!selectedProvider)
                throw new Error('Invalid wallet provider index');
            const wallet = accessContext.initWallet(selectedProvider);
            yield wallet.connect();
            if (accountName && authorization)
                yield wallet.login(accountName, authorization);
            if (accountName && !authorization)
                yield wallet.login(accountName);
            if (!accountName && !authorization)
                yield wallet.login();
            setActiveProviderIndex(providerIndex);
            dispatch({ type: 'LOGIN_SUCCESS', payload: { wallet } });
        }
        catch (error) {
            dispatch({ type: 'LOGIN_ERROR', payload: { error } });
        }
    });
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield ((_a = state.wallet) === null || _a === void 0 ? void 0 : _a.logout());
        removeActiveProviderIndex();
        dispatch({ type: 'LOGOUT' });
    });
    react_1.default.useEffect(() => {
        if (!isFirstRender.current)
            return;
        if (!state.accessContext)
            dispatch({ type: 'SET_ACCESS_CONTEXT', payload: { accessContext } });
        if (autoLogin && !state.wallet && activeProviderIndex !== undefined)
            login({ providerIndex: activeProviderIndex });
        isFirstRender.current = false;
    });
    return react_1.default.createElement(TransitContext_1.TransitContext.Provider, { value: Object.assign(Object.assign({}, state), { login, logout }) }, children);
};
exports.default = exports.TransitProvider;
//# sourceMappingURL=TransitProvider.js.map